<template>
    <b-card-header class="title-display">
        <!--
        <b-row>
            <b-col cols="auto">
                <b-row>
                    <b-col cols="auto" class="title-display-label">
                        AY{{ application.academic_year }} Application For:
                    </b-col>
                    <b-col class="title-display-content">
                        {{ applicantName(application.applicant_id) }} ({{ application.application_id }})
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="auto">
                <b-row>
                    <b-col cols="auto" class="title-display-label">
                        Applicant:
                    </b-col>
                    <b-col class="title-display-content">
                        {{ applicantName(application.applicant_id) }}
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="auto">
                <b-row>
                    <b-col cols="auto" class="title-display-label">
                        Application Type:
                    </b-col>
                    <b-col cols="auto" class="title-display-content">
                        {{ applicationType }}
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="auto">
                <b-row>
                    <b-col cols="auto" class="title-display-label">
                        Academic Year:
                    </b-col>
                    <b-col cols="auto" class="title-display-content">
                        {{ application.academic_year }}
                    </b-col>
                </b-row>
            </b-col>
            <b-col cols="auto" class="title-display-label">
                <b-row>
                    <b-col cols="auto">
                        Application ID:
                    </b-col>
                    <b-col cols="auto" class="title-display-content">
                        {{ application.application_id }}
                    </b-col>
                </b-row>
            </b-col>
        </b-row>
        <div class="dotted-rule"></div>
    -->
        <slot />
    </b-card-header>
</template>

<script>
import { mapGetters } from 'vuex';
import { Arc } from '$Shared/@arc/vue-arc';

export default {
    name: 'ApplicationHeader',

    data() {
        return {
            budgetItems: null,
        };
    },

    computed: {
        ...mapGetters({
            application: 'application/applicationData',
            applicantName: 'application/applicantName',
        }),

        applicationType() {
            return Arc.Text.ucWords(this.application.application_type);
        },
    },
};
</script>

<style lang="scss">
.title-display {
    font-size: 18px;
    color: #fafafa;
    background: linear-gradient(180deg, rgba(56, 0, 100, 1) 0%, rgba(56, 0, 100, 0.8) 100%);
    border-bottom-width: 0px;
}

.title-display-label {
    font-weight: normal;
    text-align: right;
}

.title-display-content {
    font-weight: bolder;
    text-align: left;
}
</style>
